import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core";

export default function AddCohort({ open, onClose, onSave, existingCohorts = [] }) {
    const [newCohort, setNewCohort] = useState({
        name: "",
        description: "",
        // survey_link: "",
        memberEmails: ""
    });

    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewCohort((prev) => ({ ...prev, [name]: value }));
    };

    const validateInput = () => {
        const errs = {};

        // cohort name validation
        const trimmedName = newCohort.name.trim();
        if(!trimmedName) {
            errs.name = "Cohort name is required.";
        } else if (trimmedName.length > 100) {
            errs.name = "Cohort name must not exceed 100 characters.";
        } else if (!/^[a-zA-Z0-9\s\-_&.,!?()']+$/.test(trimmedName)) {
            errs.name = "Cohort name contains invalid characters. Only letters, numbers, spaces, and basic punctuation (-, _, &) are allowed.";
        }

        // description validation
        if (newCohort.description && newCohort.description.length > 500) {
            errs.description = "Description must be 500 characters or less.";
        }

        // // survey link validation
        // const trimmedSurveyLink = newCohort.survey_link.trim();
        // if (!trimmedSurveyLink) {
        //     errs.survey_link = "Survey link is required.";
        // } else if (!/^https?:\/\/[^\s]+$/.test(trimmedSurveyLink)) {
        //     errs.survey_link = "Survey link must start with http:// or https:// and be a valid URL.";
        // } else {
        //     // TODO: Check this
        //     // Optional: check for entrepreneurial-mindset or known survey domain
        //     // This is just an example - adjust the pattern based on your requirements
        //
        //
        //     // if (!/entrepreneurial-mindset|survey\.entremap\.org/.test(trimmedSurveyLink)) {
        //     //     errs.survey_link = "Survey link must be from an approved survey provider.";
        //     // }
        //
        //     // check for duplicates
        //     const duplicate = existingCohorts.find(
        //         (c) => c.survey_link === trimmedSurveyLink
        //     );
        //     if (duplicate) {
        //         errs.survey_link = "This survey link is already used by another cohort.";
        //     }
        // }

        // validate member emails
        if (newCohort.memberEmails) {
            const emails = newCohort.memberEmails.split(/[\n,]+/).map(email => email.trim()).filter(email => email);
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            const invalidEmails = emails.filter(email => !emailRegex.test(email));
            if (invalidEmails.length > 0) {
                errs.memberEmails = `Invalid email format: ${invalidEmails.join(', ')}`;
            }
        }

        setErrors(errs);
        return Object.keys(errs).length === 0;
    };

    // In AddCohort.js, add logging to handleSave
    const handleSave = () => {
        if (!validateInput()) return;

        // Process member emails
        const memberEmails = newCohort.memberEmails
            ? newCohort.memberEmails.split(/[\n,]+/)
                .map(email => email.trim())
                .filter(email => email)
            : [];

        console.log('Sending to API - Member emails:', memberEmails);

        onSave({
            ...newCohort,
            name: newCohort.name.trim(),
            description: newCohort.description.trim(),
            // survey_link: newCohort.survey_link.trim(),
            memberEmails: memberEmails // Make sure this is included
        });

        // Reset form
        setNewCohort({ name: "", description: "", survey_link: "", memberEmails: "" });
        setErrors({});
    };

    const handleClose = () => {
        // Reset form when closing
        setNewCohort({ name: "", description: "", survey_link: "", memberEmails: "" });
        setErrors({});
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Add New Cohort</DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    label="Cohort Name"
                    name="name"
                    value={newCohort.name}
                    onChange={handleInputChange}
                    fullWidth
                    error={!!errors.name}
                    helperText={errors.name}
                    inputProps={{ maxLength: 100 }}
                />
                <TextField
                    margin="dense"
                    label="Cohort Description"
                    name="description"
                    value={newCohort.description}
                    onChange={handleInputChange}
                    fullWidth
                    multiline
                    rows={4}
                    error={!!errors.description}
                    helperText={errors.description}
                    inputProps={{ maxLength: 500 }}
                />
                <TextField
                    margin="dense"
                    label="Member Emails (optional)"
                    name="memberEmails"
                    value={newCohort.memberEmails}
                    onChange={handleInputChange}
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Enter email addresses, separated by commas or new lines"
                    helperText="Add existing users by their email addresses"
                    error={!!errors.memberEmails}
                    helperText={errors.memberEmails}
                />
                {/*<TextField*/}
                {/*    margin="dense"*/}
                {/*    label="Cohort Survey Link"*/}
                {/*    name="survey_link"*/}
                {/*    value={newCohort.survey_link}*/}
                {/*    onChange={handleInputChange}*/}
                {/*    fullWidth*/}
                {/*    error={!!errors.survey_link}*/}
                {/*    helperText={errors.survey_link}*/}
                {/*    placeholder="https://..."*/}
                {/*/>*/}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}